import type { RequestListResponse, RequestListType } from '@/types/request';

const backendUrl = process.env.REACT_APP_BACKEND_URL ?? '';

export interface RequestListFilters {
  subordinates?: boolean;
  managerDepartmentRequests?: boolean;
}

export const getRequestList = async (
  type: RequestListType,
  token?: string,
  filters?: RequestListFilters,
): Promise<RequestListResponse> => {
  const params = new URLSearchParams();

  if (type !== 'draft') {
    if (filters?.subordinates) params.set('subordinates', '1');
    if (filters?.managerDepartmentRequests) params.set('managerDepartmentRequests', '1');
  }

  const query = params.toString();
  const url = `${backendUrl}/api/requesthr/list/${type}${query ? `?${query}` : ''}`;
  const response = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : undefined,
  });

  if (!response.ok) {
    const payload = await response.json().catch(() => null);
    throw new Error(payload?.message ?? `Не удалось получить список ${type}`);
  }

  return response.json();
};
